import React, { useEffect } from "react";
import { Sortable, SortableContent, SortableItem } from "@/modern/components/ui/sortable";
import { ViewOrganizerRow } from "./ViewOrganizerRow";

interface ViewOrganizerListProps {
  views: any[];
  project: any;
  user: any;
  editorHandler: any;
  viewManager: any;
  canEdit: boolean;
  onReorder: (reorderedViews: any[]) => void;
  onDelete: (view: any) => void;
  onToggleVisibility: (view: any) => void;
}

export const ViewOrganizerList = ({
  views,
  project,
  user,
  editorHandler,
  viewManager,
  canEdit,
  onReorder,
  onDelete,
  onToggleVisibility
}: ViewOrganizerListProps) => {
  const [items, setItems] = React.useState(views);

  useEffect(() => {
    setItems(views);
  }, [views]);

  const handleReorder = (reorderedItems: any[]) => {
    setItems(reorderedItems);
    onReorder(reorderedItems);
  };

  return (
    <div className="flex flex-col h-full">
      {items.length > 0 ? (
        <Sortable
          value={items}
          onValueChange={handleReorder}
          getItemValue={(item) => item.id}
        >
          <SortableContent className="space-y-2">
            {items.map((view) => (
              <SortableItem key={view.id} value={view.id}>
                <ViewOrganizerRow
                  view={view}
                  project={project}
                  user={user}
                  editorHandler={editorHandler}
                  viewManager={viewManager}
                  canEdit={canEdit}
                  onDelete={onDelete}
                  onToggleVisibility={onToggleVisibility}
                />
              </SortableItem>
            ))}
          </SortableContent>
        </Sortable>
      ) : (
        <div className="flex items-center justify-center h-full min-h-32">
          <p className="text-sm text-muted-foreground">
            No views found for this folder.
          </p>
        </div>
      )}
    </div>
  );
};
